export enum NotificationServiceType {
    Push = 1,
    Email = 2,
    Sms = 3,
    Telegram = 4,
    Max = 5,
    //WhatsApp = 6
}

export const enumLabel = (value?: NotificationServiceType) => {
    switch (value) {
        case NotificationServiceType.Push:
            return 'Push';
        case NotificationServiceType.Email:
            return 'Email';
        case NotificationServiceType.Sms:
            return 'Sms';
        case NotificationServiceType.Telegram:
            return 'Telegram';
        case NotificationServiceType.Max:
            return 'Max';
        default:
            return '';
    }
};
